export enum CardSuit {
    CLUBS = 'clubs',
    SPADES = 'spades',
    HEARTS = 'hearts',
    DIAMONDS = 'diamonds',
    ALL = 'all',
}
